import { jsx as i, jsxs as b } from "react/jsx-runtime";
import h, { useEffect as B } from "react";
import { useFoundation as k, createComponent as l, useClassNames as m, Tag as g } from "@rmwc/base";
import { Icon as I } from "@rmwc/icon";
import { withRipple as C } from "@rmwc/ripple";
import { MDCIconButtonToggleFoundation as R } from "@material/icon-button";
const _ = (e) => {
  const { foundation: n, ...t } = k({
    props: e,
    elements: { rootEl: !0 },
    foundation: ({ rootEl: s, emit: a }) => new R({
      addClass: (o) => s.addClass(o),
      removeClass: (o) => s.removeClass(o),
      hasClass: (o) => s.hasClass(o),
      setAttr: (o, d) => s.setProp(o, d),
      notifyChange: (o) => a("onChange", o)
    })
  }), { rootEl: u } = t, c = e.checked !== void 0 ? e.checked : n.isOn();
  B(() => {
    c !== n.isOn() && n.toggle(c);
  }, [n, c]);
  const r = (s) => {
    var a;
    (a = e.onClick) == null || a.call(e, s), n.handleClick();
  };
  return u.setProp("onClick", r, !0), { isOn: c, foundation: n, ...t };
}, P = l(function({ ...n }, t) {
  return n.onIcon ? /* @__PURE__ */ i(N, { ...n, ref: t }) : /* @__PURE__ */ i(T, { ...n, ref: t });
}), N = l(
  function(n, t) {
    const { icon: u, onIcon: c, foundationRef: r, ...s } = n, { isOn: a, rootEl: o } = _(n);
    return /* @__PURE__ */ b(
      v,
      {
        "aria-pressed": a,
        ...o.props(s),
        tag: "button",
        ref: t,
        children: [
          /* @__PURE__ */ i("div", { className: "mdc-icon-button__ripple" }),
          /* @__PURE__ */ i(f, { icon: u }),
          /* @__PURE__ */ i(f, { icon: c, on: !0 })
        ]
      }
    );
  }
), T = C({
  surface: !1,
  unbounded: !0
})(
  l(function(n, t) {
    const { checked: u, label: c, foundationRef: r, children: s, icon: a, ...o } = n, d = m(n, [
      "mdc-icon-button",
      {
        "mdc-icon-button--on": u
      }
    ]);
    return /* @__PURE__ */ b(
      g,
      {
        tag: "button",
        role: "button",
        tabIndex: 0,
        "aria-label": c,
        ...o,
        className: d,
        ref: t,
        children: [
          /* @__PURE__ */ i("div", { className: "mdc-icon-button__ripple" }),
          /* @__PURE__ */ i(I, { icon: a, tag: "i" })
        ]
      }
    );
  })
), v = C({
  surface: !1,
  unbounded: !0
})(
  l(function(n, t) {
    const { checked: u, ...c } = n, r = m(n, [
      "mdc-icon-button",
      {
        "mdc-icon-button--on": u
      }
    ]);
    return /* @__PURE__ */ i(
      g,
      {
        tag: "button",
        role: "button",
        tabIndex: 0,
        ...c,
        className: r,
        ref: t
      }
    );
  })
), f = h.memo(function(n) {
  const { on: t, ...u } = n, c = m(n, [
    "mdc-icon-button__icon",
    {
      "mdc-icon-button__icon--on": n.on
    }
  ]);
  return /* @__PURE__ */ i(I, { ...u, className: c });
});
export {
  P as IconButton
};
